import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { Preference } from '../models/preference';
import { environment } from '../../environments/environment';

@Injectable()
export class PreferencesService {

  baseUrl = environment.preferenceServiceBaseUrl;

  constructor(private http: HttpClient) { }

  setPreference(context: 'CUSTOMER' | 'USER' | 'MARKET' | 'PROJECT' | 'WORKSHEET', uuid: string, code: string, value: any) {
    const url = `${this.baseUrl}value/${context}~${uuid}/${code}`;
    const headers = new HttpHeaders()
      .set('Accept', 'application/json');
    return this.http.put<any>(url, value, { headers });
  }

  getPreferences(context: 'CUSTOMER' | 'USER' | 'MARKET' | 'PROJECT' | 'WORKSHEET', uuid: string): Observable<{ [key: string]: Preference }> {
    const url = `${this.baseUrl}value/${context}~${uuid}`;
    const headers = new HttpHeaders()
    .set('Accept', 'application/json');
    return this.http.get<any>(url, { headers })
    .map(prefs => {
      return prefs.reduce((prev, curr) => {
        return Object.assign(prev, { [curr['Preference Code']]: curr});
      }, {});
    });
  }

  getPreferencesByIds(context: 'CUSTOMER' | 'USER' | 'MARKET' | 'PROJECT' | 'WORKSHEET', code: string, ids: string[]): Observable<{ [key: string]: Preference }> {
    const url = `${this.baseUrl}values/${context}/${code}`;
    const headers = new HttpHeaders()
    .set('Accept', 'application/json');
    return this.http.post<any>(url, ids, { headers })
    .map(prefs => {
      return prefs.reduce((prev, curr) => {
        return Object.assign(prev, { [curr['Id']]: curr});
      }, {});
    });
  }

  deletePreference(context: 'CUSTOMER' | 'USER' | 'WORKSHEET', uuid: string, code: string) {
    const url = `${this.baseUrl}value/${context}~${uuid}/${code}`;
    const headers = new HttpHeaders()
      .set('Accept', 'application/json');
    return this.http.delete<any>(url, { headers });
  }
}



// WEBPACK FOOTER //
// /codebuild/output/src3408204168/src/bitbucket.org/tesscotds/webclient/src/api/services/preferences.service.ts